export enum OperatingunitRoles {
  dach_support_admin_pva = 'dach_support_admin-pva',
  dach_telesales_pva = 'dach_telesales-pva',
  dach_telesales_supervisor_pva = 'dach_telesales_supervisor_user-PVA',
  dach_support_desk_pva = 'dach_support_desk-pva',
  dach_super_user_pva = 'dach_super_user-pva',
  dach_marketing_user_pva = 'dach_marketing_user-pva',
  dach_support_admin_sg = 'dach_support_admin-sg',
  dach_telesales_sg = 'dach_telesales-sg',
  dach_telesales_supervisor_sg = 'dach_telesales_supervisor_user-SG',
  dach_support_desk_sg = 'dach_support_desk-sg',
  dach_super_user_sg = 'dach_super_user-sg',
  dach_marketing_user_sg = 'dach_marketing_user-sg'
}

export enum OperatingunitRolesOptionNames {
  dach_support_admin_pva = 'DACH Support Admin PVA',
  dach_telesales_pva = 'DACH Telesales PVA',
  dach_telesales_supervisor_pva = 'DACH Telesales Supervisor User PVA',
  dach_support_desk_pva = 'DACH Support Desk PVA',
  dach_super_user_pva = 'DACH Super User PVA',
  dach_marketing_user_pva = 'DACH Marketing PVA',
  dach_support_admin_sg = 'DACH Support Admin SG',
  dach_telesales_sg = 'DACH Telesales SG',
  dach_telesales_supervisor_sg = 'DACH Telesales Supervisor User SG',
  dach_support_desk_sg = 'DACH Support Desk SG',
  dach_super_user_sg = 'DACH Super User SG',
  dach_marketing_user_sg = 'DACH Marketing SG'
}
